
define('YearMakeModel.Searcher.EntryPoint',
	[
		'YearMakeModel.Searcher.View'
	],
	function (
		YearMakeModelSearcherView
	) {
		'use strict';

		return {
			mountToApp: function mountToApp(container) {
				var layout = container.getComponent('Layout');
				if (layout) {
					layout.addChildView('UC.YearMakeModel', function () {
						return new YearMakeModelSearcherView({container : container});
					});
				}
			}
		};
	});
